import { getThumbnailURL } from '../../constants/common';
import useAuthFetchBlob from '../common/download/useAuthFetchBlob';

export default function useAssetThumbnail(displayImageId, size = 80) {
    const { blobURL } = useAuthFetchBlob({
        url: displayImageId ? getThumbnailURL(displayImageId + '.webp', 'assets', size) : undefined
    });

    return blobURL;
}
